export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/transcripts.780cea4.svg";